import React from 'react';

const STATS = [
    { count: 70, suffix: '%', label: 'of angel-backed companies never properly diligenced' },
    { count: 2, prefix: '<', suffix: '%', label: 'of applications result in investment' },
    { count: 60, prefix: '~', suffix: '%', label: 'of diligence auto-populated by AI' },
    { count: 0, prefix: '£', label: 'cost to the angel network', pink: true },
];

const GLOWS = [
    { top: -80, left: -100, size: 420, c: 'rgba(252,119,133,0.36)' },
    { top: -80, right: -100, size: 440, c: 'rgba(74,103,255,0.38)' },
];

const AngelStatBand = () => (
    <section className="lp-stats lp-stats--glow">
        <div className="lp-stats-bg" aria-hidden="true">
            {GLOWS.map((g, i) => (
                <i key={i} style={{ top: g.top + 'px', left: g.left != null ? g.left + 'px' : 'auto', right: g.right != null ? g.right + 'px' : 'auto', width: g.size + 'px', height: g.size + 'px', background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`, filter: 'blur(74px)' }} />
            ))}
        </div>
        <div className="lp-stats-grid">
            {STATS.map((s, i) => (
                <div key={i} data-lp-reveal data-lp-delay={i * 80}>
                    <div className={`lp-stat-num ${s.pink ? 'pink' : ''}`} data-count={s.count} data-prefix={s.prefix || ''} data-suffix={s.suffix || ''}>
                        {(s.prefix || '') + s.count + (s.suffix || '')}
                    </div>
                    <div className="lp-stat-label">{s.label}</div>
                </div>
            ))}
        </div>
    </section>
);

export default AngelStatBand;
